var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.dataList.length > 0 ? _c("div", {
    staticClass: "recommend-law-container"
  }, [_c("div", {
    staticClass: "recommend-title"
  }, [_vm._v("相关法规")]), _c("div", {
    staticClass: "recommend-list"
  }, _vm._l(_vm.visibleList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "recommend-item",
      on: {
        click: function click($event) {
          return _vm.viewLawDetail(item.policyUrl);
        }
      }
    }, [_c("div", {
      staticClass: "two-line-ellipsis"
    }, [_vm._v(_vm._s(item.policyName))])]);
  }), 0), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataList.length > 5,
      expression: "dataList.length > 5"
    }],
    staticClass: "recommend-footer"
  }, [_c("div", {
    staticClass: "page-btn",
    class: {
      "disabled-btn": _vm.pagination.current === 0
    },
    on: {
      click: _vm.preHandler
    }
  }, [_vm._v("上一页")]), _c("div", {
    staticClass: "page-btn",
    class: {
      "disabled-btn": (_vm.pagination.current + 1) * _vm.pagination.size >= _vm.dataList.length
    },
    on: {
      click: _vm.nextHandler
    }
  }, [_vm._v("下一页")])]), _c("van-popup", {
    style: {
      width: "calc(100vw - 32px)",
      height: "95%",
      "z-index": 3006
    },
    attrs: {
      round: "",
      closeable: ""
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "law-title"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lawIdList.length > 1,
      expression: "lawIdList.length > 1"
    }],
    on: {
      click: _vm.previous
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "pre"
    }
  }), _vm._v(" 返回")], 1)]), _c("div", {
    staticClass: "law-content"
  }, [_c("div", [_vm._v(_vm._s(_vm.lawInfo["title"]))]), _c("div", {
    staticClass: "law-attr"
  }, [_c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文机关：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["pubOffice"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文字号：")]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo["docNum"])
    }
  })]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发布日期：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["releaseDate"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("法规时效：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["status"]))])])]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo.content)
    }
  })])])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };